import { app } from "modular-openscriptjs";
import OffcanvasComponent from "../OffcanvasComponent";

const h = app("h");

export default class DeliveryAddressOffcanvas extends OffcanvasComponent {
    name = "DeliveryAddressOffcanvas";
    
    render(...args) {
        return h.$(h.div({ class: "offcanvas-body" }, ...args));
    }
}
